import { ScheduleForeman } from '@root/globalTypes';
import { getFullName } from '@utils/textHelpers';

export const getForemanName = (foreman?: ScheduleForeman | null) =>
  foreman?.fullName || getFullName(foreman?.firstName, foreman?.lastName);
